import { Routes, Route } from 'react-router-dom'
import React, { useEffect } from 'react'
import './App.less'
import PublicRoute from 'components/routes/publicRoute'
import PageError from 'components/routes/pageError'
import CoreLayout from 'components/layout'
import Home from 'pages/Home'
import CourseInfo from 'pages/CourseInfo'
import CourseInfoGroup from 'pages/CourseInfoGroup'
import CourseInfoBranch from 'pages/CourseInfoBranch'

import Enrollment from 'pages/Enrollment'
import Registration from 'pages/Registration'
import LeaveCondition from 'pages/LeaveCondition'
import Cooperative from 'pages/Cooperative'
import ServiceSUT from 'pages/ServiceSUT'
import Questions from 'pages/Questions'

function App() {
  return (
    <Routes>
      <Route path='/' element={<CoreLayout />}>
        <Route element={<PublicRoute />}>
          <Route path='/' element={<Home />} />
          <Route path='/course-introduction' element={<CourseInfo />} />
          <Route
            path='/course-introduction/:group'
            element={<CourseInfoGroup />}
          />
          <Route
            path='/course-introduction/:group/:branch'
            element={<CourseInfoBranch />}
          />
          <Route path='/enrollment' element={<Enrollment />} />
          <Route path='/enrollment/:type' element={<Registration />} />

          <Route path='/leave-conditions' element={<LeaveCondition />} />
          <Route
            path='/contact-cooperative-education'
            element={<Cooperative />}
          />
          <Route path='/university-service' element={<ServiceSUT />} />
          <Route path='/questions' element={<Questions />} />
        </Route>

        <Route path='*' element={<PageError />} />
      </Route>
    </Routes>
  )
}

export default App
